import React, { createContext, useState } from 'react'

import { merge } from 'lodash'

import { SobaLayoutSettings } from 'app/components/SobaLayout/settings'

const SettingsContext = createContext({
    settings: SobaLayoutSettings,
    updateSettings: () => {},
})

export const SettingsProvider = ({ settings, children }) => {
    const [currentSettings, setCurrentSettings] = useState(
        settings || SobaLayoutSettings
    )

    const handleUpdateSettings = (update = {}) => {
        const merged = merge({}, currentSettings, update)
        setCurrentSettings(merged)
    }

    return (
        <SettingsContext.Provider
            value={{
                settings: currentSettings,
                updateSettings: handleUpdateSettings,
            }}
        >
            {children}
        </SettingsContext.Provider>
    )
}

export default SettingsContext
